import { ChangeEvent, FocusEvent, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Flex } from 'reflexbox';

import SearchIcon from 'packages/kakapo-ui-kit/assets/icons/SearchIcon';
import RelativeContainer from 'packages/kakapo-ui-kit/components/atoms/RelativeContainer';
import Breakpoint from 'packages/kakapo-ui-kit/helpers/Breakpoint';

interface IProps {
	placeholder?: string;
	autoFocus?: boolean;
	onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
	value?: string;
}

const Element = styled.input`
	width: 100%;
	display: block;
	color: ${(props) => props.theme.colors.slateBlue};
	background-color: ${(props) => props.theme.colors.lightBlueLight};
	border-radius: 25px;
	height: 50px;
	font-size: 16px;
	padding: 10px 20px 10px 46px;
	transition: box-shadow 70ms ease-out, background-color 70ms ease-out;

	&:focus {
		background: #ffffff;
		box-shadow: 0 1px 6px 0 rgba(72, 64, 190, 0.6);
	}

	@media screen and (max-width: ${Breakpoint.Small}) {
		font-size: 13px;
		padding: 8px 16px;
	}
`;

const Icon = styled.div`
	z-index: 1;
	pointer-events: none;
	position: relative;
	left: 20px;
	top: 2px;
	width: 0;

	@media screen and (max-width: ${Breakpoint.Small}) {
		display: none;
	}
`;

export default function SearchFieldBig({
	placeholder,
	autoFocus,
	onFocus,
	onChange,
	value,
}: IProps) {
	const ref = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (autoFocus) {
			ref.current?.focus();
		}
	}, [autoFocus]);

	return (
		<RelativeContainer>
			<Flex flexDirection="row" alignItems="center">
				<Icon>
					<SearchIcon />
				</Icon>

				<Element
					ref={ref}
					type="text"
					placeholder={placeholder}
					autoFocus={autoFocus}
					onFocus={onFocus}
					onChange={onChange}
					value={value}
				/>
			</Flex>
		</RelativeContainer>
	);
}
